import { Slider, SliderProps } from '@mui/material';
import { lighten } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { FormPublicDesignFragment } from '../../graphql/fragment/form.public.fragment';

interface Props {
  field: any;
  design: FormPublicDesignFragment;
  onChange: any;
  value: string;
  children?: any;
  name: string;
  id: string;
}

const Field = styled(Slider)<{ design: FormPublicDesignFragment }>`
  &.MuiSlider-root {
    color: ${({ design }) => design.colors.button};
    margin-bottom: 5vh;
  }

  .MuiSlider-markLabel {
    color: ${({ design }) => design.colors.question};
  }

  &.MuiSlider-root:hover {
    color: ${({ design }) => lighten(0.2, design.colors.button)};
  }
`;

export const StyledSliderInput: React.FC<Props & SliderProps> = ({
  children,
  ...props
}) => {
  const min = parseInt(
    props.field.options[0].value !== 'null' ? props.field.options[0].value : '0'
  );
  const max = parseInt(
    props.field.options[1].value !== 'null'
      ? props.field.options[1].value
      : '100'
  );
  const steps = parseInt(
    props.field.options[2].value !== 'null' ? props.field.options[2].value : '1'
  );
  // logic here because we want end markers always, but step markers only sometime
  // if max is able to be divided by step size evenly and the amount of possible steps is 10 or less,
  // create the steps array to visually show steps.
  // if max divided by step size is 10 or less, show the steps visually on slider
  const stepsArray = [];
  if (max / steps <= 10) {
    for (let i = min + steps; i < max; i += steps) {
      stepsArray.push({ value: i, label: String(i) });
    }
  }

  const marks = [
    {
      value: min,
      label: min.toString(),
    },
    ...stepsArray,
    {
      value: max,
      label: max.toString(),
    },
  ];

  return (
    <Field
      marks={marks}
      step={steps}
      min={min}
      max={max}
      valueLabelDisplay='auto'
      {...props}
    >
      {children}
    </Field>
  );
};
